/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Base,
    BaseFromJSON,
    BaseFromJSONTyped,
    BaseToJSON,
    RelationshipType,
    RelationshipTypeFromJSON,
    RelationshipTypeFromJSONTyped,
    RelationshipTypeToJSON,
    TimeStamps,
    TimeStampsFromJSON,
    TimeStampsFromJSONTyped,
    TimeStampsToJSON,
} from './';

/**
 * The header and text of the referral link text on the signup page.
 * @export
 * @interface ReferralLinkText
 */
export interface ReferralLinkText {
    /**
     * 
     * @type {string}
     * @memberof ReferralLinkText
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof ReferralLinkText
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof ReferralLinkText
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof ReferralLinkText
     */
    header?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralLinkText
     */
    description?: string;
    /**
     * 
     * @type {RelationshipType}
     * @memberof ReferralLinkText
     */
    relationshipType: RelationshipType;
}

export function ReferralLinkTextFromJSON(json: any): ReferralLinkText {
    return ReferralLinkTextFromJSONTyped(json, false);
}

export function ReferralLinkTextFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralLinkText {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'header': !exists(json, 'header') ? undefined : json['header'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'relationshipType': RelationshipTypeFromJSON(json['relationshipType']),
    };
}

export function ReferralLinkTextToJSON(value?: ReferralLinkText | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'header': value.header,
        'description': value.description,
        'relationshipType': RelationshipTypeToJSON(value.relationshipType),
    };
}


